import moment = require("moment");
import { AsyncState } from "widgets-for-react"
import * as Immutable from "immutable"

export type QuotationRequest = {
  required_delivery_date: MonthYear,
  project_name: string,
  project_city: string,
  project_country: string,
  project_address: string
}

export type MonthYear = {
  month: string,
  year: string
}

export const monthOptions  =  Immutable.List([
  { value: "1", label: "January"},
  { value: "2", label: "February"},
  { value: "3", label: "March"},
  { value: "4", label: "April"},
  { value: "5", label: "May"},
  { value: "6", label: "June"},
  { value: "7", label: "July"},
  { value: "8", label: "August"},
  { value: "9", label: "September"},
  { value: "10", label: "October"},
  { value: "11", label: "November"},
  { value: "12", label: "December"}]
)

export let yearOptions = Immutable.List([])
const thisYear = moment().year()
for (var i=0; i<10; i++) {
  yearOptions = yearOptions.push(thisYear + i)
}

export type Product = {
  Id: string,
  Name: string
}

export type ProductConfiguration = {
  Id: string,
  ProductId: string,
  Count: number,
  CharacteristicArray: AsyncState<Characteristic[]>,
  CharacteristicValues: CharacteristicValue[],
  SpecialFeature: string,
  SelectedCharacteristic: string,
  Submitted: boolean
}

export type CharacteristicValue = {
  CharacteristicId: string,
  CharacteristicValueId: string
}

export type Characteristic = {
  Text: string,
  Id: string,
  SelectorType: string, // TODO This will be an enum
  DataType: string,
  ValueOptions: ValueOption[],
  InOverview: boolean,
  Range: string
}

export type ValueOption = {
  Value: string,
  ValueId: string
}

export type RequestToRetry = {
  kind: "none"
} | {
  kind: "products"
  loading: AsyncState<Product[]>
} | {
  kind: "quotation_response"
  loading: AsyncState<QuotationResponse>
} | {
  kind: "productConfigurations"
  loading: Immutable.Map<string, ProductConfiguration>
}

export type QuotationRequestErrorMessage = {
  Message: string
  QuotationRequestProductId: string
  CharacteristicId: string
}

export type QuotationResponse = {
  Status: string,
  SapQuotationRequestId: string
  ErrorMessages: QuotationRequestErrorMessage[]
}

export type SubmitQuotationData = {
  CustomerId: string
  Name: string
  RequiredDeliveryDate: MonthYear
  ProjectName: string
  ProjectCity: string
  ProjectCountry: string
  ProjectAddress: string
  ProductConfigurations: ProductConfiguration[]
  LanguageCode: string
  Products: Product[]
  CharacteristicDefinitions: Characteristic[]
}